import { SET_NEW_PATIENT,SET_INIT_PATIENT, SET_NEW_PATIENT_ID, SET_PATIENT, SET_AUTHENTICATED_USER, RESET_AUTHENTICATED_USER, SET_DATA_LIST } from "../actions";

export const setPatientToInit = (payload)=>{
    return {
          type : SET_INIT_PATIENT,
          payload
    }
}

export const setNewPatient = (payload)=>{
    return {
          type : SET_NEW_PATIENT,
          payload
    }
}

export const setNewPatientIDNumber = (payload)=>{
    return {
          type : SET_NEW_PATIENT_ID,
          payload
    }
}

export const setPatient = (payload)=>{
    return {
          type : SET_PATIENT,
          payload
    }
}

export const setAuthenticatedUser = (payload)=>{
    return {
          type : SET_AUTHENTICATED_USER,
          payload
    }
}

export const resetAuthenticatedUser = ()=>{
    return {
          type : RESET_AUTHENTICATED_USER,
    }
}


export const setDataList = (list, listKey)=>{
    return {
        type : SET_DATA_LIST,
        payload: {[listKey] : list}
    }
}